/* eslint-disable no-use-before-define */
import React, { useContext, useEffect, useState } from 'react';
import { querySummary } from '../controllers/controller';
import { QuerySummary as QuerySummaryType } from '@coveo/headless';
import SecondCall from './second-call-context';

type QuerySummaryProps = {
  extraClasses?: string;
};

const SUMMARY_PLACEHOLDERS = Object.freeze({
  firstResult: '{{firstResult}}',
  lastResult: '{{lastResult}}',
  total: '{{totalResults}}',
  query: '{{query}}'
});

function QuerySummary({ extraClasses = '' }: QuerySummaryProps) {
  const { dataset } = document.getElementsByClassName(
    'coveo-listing__data-wrapper'
  )[0] as HTMLElement;
  const summaryText = (dataset.summaryText as string).split('|')[0];
  const queryText = (dataset.summaryText as string).split('|')[1];
  const [state, setState] = useState((querySummary as QuerySummaryType).state);
  const secondCallContext = useContext(SecondCall);

  const text = Object.keys(SUMMARY_PLACEHOLDERS).reduce((acc, placeholder) => {
    if (
      acc.includes(
        SUMMARY_PLACEHOLDERS[placeholder as keyof typeof SUMMARY_PLACEHOLDERS]
      )
    ) {
      if (placeholder === 'query' && state.query != '') {
        acc += queryText;
      }

      let replaceVal = state[placeholder as keyof typeof SUMMARY_PLACEHOLDERS]
        ? state[placeholder as keyof typeof SUMMARY_PLACEHOLDERS].toString()
        : '';

      if (secondCallContext.secondCall) {
        if (placeholder === 'firstResult') {
          if (secondCallContext.selectedPage === 1) {
            replaceVal = '1';
          } else if (secondCallContext.selectedPage === 2) {
            replaceVal = '11';
          }
        }

        if (placeholder === 'lastResult') {
          if (secondCallContext.selectedPage === 1) {
            if (secondCallContext.filteredResults.length < 10)
              replaceVal = secondCallContext.filteredResults.length.toString();
            else {
              replaceVal = '10';
            }
          } else if (secondCallContext.selectedPage === 2) {
            if (
              secondCallContext.limitValue &&
              parseInt(replaceVal) > secondCallContext.limitValue
            ) {
              replaceVal = secondCallContext.limitValue.toString();
            }

            if (
              secondCallContext.filteredResults.length <
              secondCallContext.limitValue
            )
              replaceVal = secondCallContext.filteredResults.length.toString();
          }
        }

        if (placeholder === 'total') {
          if (parseInt(replaceVal) > secondCallContext.limitValue) {
            replaceVal = secondCallContext.limitValue.toString();
          }
          if (parseInt(replaceVal) > secondCallContext.filteredResults.length)
            replaceVal = secondCallContext.filteredResults.length.toString();
        }
      }
      acc = acc.replace(
        SUMMARY_PLACEHOLDERS[placeholder as keyof typeof SUMMARY_PLACEHOLDERS],
        replaceVal
      );
    }

    return acc;
  }, summaryText);

  useEffect(
    () =>
      (querySummary as QuerySummaryType).subscribe(() =>
        setState((querySummary as QuerySummaryType).state)
      ),
    [querySummary]
  );

  return (
    <>
      {state.total > 0 && (
        <div
          className={`query-summary ${extraClasses}`}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </>
  );
}

export default QuerySummary;
